import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { renderTag } from 'hb-builder/components/BuilderComponents/dynamic/EmailList/EmailListLayouts/utils';
import type { EmailListLayoutsDynamicAttributes } from 'hb-builder/components/BuilderComponents/dynamic/EmailList/types';
import type { Event } from 'hb-builder/components/BuilderComponents/dynamic/types/event';

type ListItemProps = {
  dynamicAttributes: EmailListLayoutsDynamicAttributes;
} & Pick<
  Event,
  | 'cover_picture'
  | 'locations'
  | 'network_categories'
  | 'start_date'
  | 'title'
  | 'total_attendees'
  | 'webinar_url'
>;

const ListItem = ({
  cover_picture: coverPicture,
  dynamicAttributes,
  locations,
  network_categories: categories,
  start_date: startDate,
  title,
  total_attendees: attendees,
  webinar_url: webinarUrl,
}: ListItemProps) => {
  const {
    displayAttendees,
    displayDate,
    displayImage,
    displayLocation,
    displayOnlineEvent,
    displayTags,
    displayTitle,
  } = dynamicAttributes.fields;

  return (
    <Wrapper>
      {displayImage && (
        <Box display="block" width="30%" dataTestId="builder-cover-wrapper">
          <StyledImg src={coverPicture} alt="cover picture" />
        </Box>
      )}
      <Box flexDirection="column" pl={4} width="70%">
        {displayTitle && <TitleWrapper>{title}</TitleWrapper>}
        {displayTags && categories?.length > 0 && (
          <Box fontSize="12px" mt={2}>
            {categories.map((category, i) =>
              renderTag(category.name, categories.length === i + 1),
            )}
          </Box>
        )}
        {displayDate && startDate && (
          <Box display="bock" mt="10px">
            <Label>{__('Date:')}</Label>
            {startDate}
          </Box>
        )}
        {displayLocation && locations && (
          <EventItem>
            <Label>{__('Location:')}</Label>
            {locations.address}
          </EventItem>
        )}
        {displayAttendees && (
          <EventItem>
            <Label>{__('Attendees:')}</Label>
            {attendees}
          </EventItem>
        )}
        {displayOnlineEvent && (
          <EventItem>
            <Label>
              {webinarUrl ? __('Online event') : __('On site event')}
            </Label>
          </EventItem>
        )}
      </Box>
    </Wrapper>
  );
};

export default ListItem;

const TitleWrapper = styled(Box).attrs(() => ({
  fontSize: '18px',
  lineHeight: '22px',
}))``;

const Wrapper = styled(Box).attrs(() => ({
  display: 'flex',
  flexDirection: {
    _: 'column',
    m: 'row',
  },
  mb: 8,
  width: '100%',
}))``;

const StyledImg = styled.img.attrs(() => ({
  height: 'auto',
  width: '100%',
}))``;

const EventItem = styled(Box).attrs(() => ({
  display: 'block',
  mt: 2,
}))``;

const Label = styled.span`
  font-size: 14px;
  font-weight: bolder;
  margin-right: 4px;
`;
